<template>
  <transition name="fade" mode="out-in">
    <keep-alive include="credit-history">
      <router-view></router-view>
    </keep-alive>
  </transition>
</template>
<script>
  export default {}
</script>